import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import useBookingStore from "../../legacy/store/bookingStore";
import MobileBookingProgress from "../components/MobileBookingProgress";
import "../styles/mobile-theme.css";

const normalizeTextList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.flatMap(normalizeTextList);
  }
  if (typeof value === "object") {
    return normalizeTextList(value.text || value.label || value.description || value.policy || "");
  }
  return String(value)
    .split(/\r?\n|(?:\s*;\s*)/)
    .map((item) => item.trim())
    .filter(Boolean);
};

const unique = (items) => Array.from(new Set(items.map((item) => String(item).trim()).filter(Boolean)));

export default function MobileBookingPolicyPage() {
  const navigate = useNavigate();
  const { policyType = "cancellation" } = useParams();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("bookingId") || "";
  const stayData = useBookingStore((state) => state.stayData);
  const snapshot = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("homevilas.bookingPolicySnapshot") || "null") || {};
    } catch (_) {
      return {};
    }
  }, []);
  const isRefund = String(policyType).toLowerCase() === "refund";
  const title = isRefund ? "Refund policy" : "Cancellation policy";
  const source = isRefund
    ? stayData?.refund_rules || stayData?.refund_policy || snapshot.refundItems
    : stayData?.cancellation_policy || snapshot.cancellationItems;
  const items = unique(normalizeTextList(source));
  const stayTitle = stayData?.title || stayData?.name || snapshot.stayTitle || "Selected stay";

  return (
    <div className="hv-mobile-shell hv-policy-page">
      <MobileBookingProgress active={2} crumb={`Home / Stays / ${title}`} />
      <main className="hv-policy-page-body">
        <button type="button" className="hv-policy-back" onClick={() => navigate(-1)}>
          <i className="bi bi-arrow-left" aria-hidden="true" /> Back
        </button>
        <section className="hv-policy-card">
          <p className="hv-policy-eyebrow">{bookingId ? `Booking ${bookingId}` : "Booking policy"}</p>
          <h1>{title}</h1>
          <p className="hv-policy-subtitle">{stayTitle}</p>
          {items.length ? (
            <ul>
              {items.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
            </ul>
          ) : (
            <p className="hv-policy-empty">
              {isRefund ? "Refund rules will be shared soon." : "Cancellation policy will be shared soon."}
            </p>
          )}
          <div className="hv-policy-switch">
            <Link to={`/booking/policy/cancellation${bookingId ? `?bookingId=${encodeURIComponent(bookingId)}` : ""}`}>Cancellation</Link>
            <Link to={`/booking/policy/refund${bookingId ? `?bookingId=${encodeURIComponent(bookingId)}` : ""}`}>Refund</Link>
          </div>
        </section>
      </main>
    </div>
  );
}
